<template>
  <AppContainer :is-loading>
    <div>
      <EPageTitleMobile :title="t(useTranslationPath(callerPath, 'header'))" :description />

      <div class="flex justify-center text-center">
        <EFormField
          id="verification_code"
          label="Verification Code"
          :errors="isInvalid ? [t(useTranslationPath(callerPath, 'invalidCode'))] : []"
        >
          <EInputCode
            id="verification_code"
            v-model="code"
            :length="codeLength"
            name="verification_code"
          />
        </EFormField>
      </div>
    </div>

    <template #bottom>
      <EButton :label="t(actionLabel)" :disabled="isActionDisabled" block @click="handleContinue" />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useSiteStore } from '@/stores/authenticated/SiteStore'
import { EButton, EFormField, EInputCode, EPageTitleMobile } from '@expansivefm/eds'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  description: {
    type: String,
    default: '',
  },
  actionLabel: {
    type: String,
    default: () => useTranslationPath('components.verification.codeVerification', 'continue'),
  },
  codeLength: {
    type: Number,
    default: 4,
  },
  siteId: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['valid'])

const { t } = useI18n()

const siteStore = useSiteStore()

const callerPath = 'components.verification.codeVerification'

const code = ref('')
const isInvalid = ref(false)
const isValidating = ref(false)

const isActionDisabled = computed(() => {
  return code.value === null || code.value.length !== props.codeLength || isValidating.value
})

const handleContinue = async () => {
  if (isActionDisabled.value) {
    return
  }

  isValidating.value = true

  isInvalid.value = !(await siteStore.validateAccessCode(props.siteId, code.value))

  isValidating.value = false

  if (isInvalid.value === false) {
    emits('valid')
  }
}
</script>
